import { Check } from "@mui/icons-material"
import { Box, Button, Grid, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { ApprovedDocumentIcon } from "../../../assets/svg/ApprovedDocumentIcon"
import { ReprovedDocumentIcon } from "../../../assets/svg/ReprovedDocumentIcon"
import { IBatchItemReturn } from "../../../model/ItemModel"
import WorkSpaceItemListFileComponentImage from "../../../pages/WorkSpaceItem/WorkSpaceItemListFileComponentImage"
import { batchActionStates } from "../BatchActionModal"
import { style } from "../BatchTheme/tooltipTheme"

interface IBatchFeedback {
    files: IBatchItemReturn[];
    handleClose: () => void;
    setBatchModalState: (set: batchActionStates) => void;
    type: "APPROVED" | "REPROVED"
}

export const BatchFeedback : React.FC<IBatchFeedback> = ({
    files,
    handleClose,
    setBatchModalState,
    type
}) => {

    const { t } = useTranslation();

    return (
        <Box sx={style}>
            <Grid
                container
            >
                <Grid
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    marginBottom="12px"
                >
                    { type == "APPROVED" && <ApprovedDocumentIcon /> }
                    { type == "REPROVED" && <ReprovedDocumentIcon /> }
                </Grid>
                <Grid 
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    marginBottom="8px"
                >
                    <Typography
                        fontWeight="600"
                        fontSize="20px"
                        fontFamily="segoe ui"
                    >
                        { type == "APPROVED" && t("BatchActionModal.approvedDocuments") }
                        { type == "REPROVED" && t("BatchActionModal.reprovedDocuments") }
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    marginBottom="20px"
                >
                    <Typography
                        fontWeight="400"
                        fontSize="14px"
                        fontFamily="segoe ui"
                    >
                        { type == "APPROVED" && t("BatchActionModal.approvedDocumentsSub") }
                        { type == "REPROVED" && t("BatchActionModal.reprovedDocumentsSub") }
                    </Typography>
                </Grid>
                <Box
                    width="540px"
                    height="340px"
                    border="1px solid #2D2D2D1A"
                    borderRadius="4px"
                    marginBottom="30px"
                >
                    <Box
                        borderBottom="1px solid #2D2D2D1A"
                    >
                        <Typography
                            fontFamily="segoe ui"
                            fontSize="14px"
                            fontWeight={600}
                            padding={1.5}
                        >
                            {t("BatchActionModal.documentName")}
                        </Typography>
                    </Box>
                    { files?.map(({
                        extension,
                        name
                    }) => (
                        <Box
                            borderBottom="1px solid #2D2D2D1A"
                            display="flex"
                            alignItems="center"
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                marginLeft={1}
                            >
                                <WorkSpaceItemListFileComponentImage 
                                    boxLayout={false}
                                    extension={extension}
                                    isFolder={false}
                                    widthIcon="20px"   
                                />
                                <Typography
                                    fontFamily="segoe ui"
                                    fontSize="14px"
                                    fontWeight={600}
                                    padding={1.5}
                                    textOverflow="ellipsis"
                                    whiteSpace="nowrap"
                                    maxWidth="500px"
                                    overflow="hidden"
                                >
                                    {name}
                                </Typography>
                            </Box>
                        </Box>
                    )) }
                </Box>
                <Grid
                    item
                    xs={12}
                >
                    <Button
                        variant="contained"
                        startIcon={<Check />}
                        fullWidth
                        sx={{
                            backgroundColor: "#22638D"
                        }}
                        onClick={() => {
                            handleClose();
                            setBatchModalState({
                                default: true,
                                approved: false,
                                reproved: false
                            });
                        }}
                    >
                        <Typography
                            textTransform="none"
                            fontFamily="segoe ui"
                        >
                            {t("BatchActionModal.concluded")}
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}